import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { localeNamespaces, localeResources } from "./locale-resources";

// Mirrors the backend's TranslationLanguageCode, so every language a form can be translated into is
// one the app can also be read in.
export const SUPPORTED_LANGUAGES = [
  "en",
  "es",
  "fr",
  "de",
  "zh",
  "pt",
  "ru",
  "ar",
  "hi",
  "vi",
  "ko",
  "ja",
  "tl",
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  zh: "中文",
  pt: "Português",
  ru: "Русский",
  ar: "العربية",
  hi: "हिन्दी",
  vi: "Tiếng Việt",
  ko: "한국어",
  ja: "日本語",
  tl: "Tagalog",
};

export const LANGUAGE_FLAGS: Record<SupportedLanguage, string> = {
  en: "🇺🇸",
  es: "🇪🇸",
  fr: "🇫🇷",
  de: "🇩🇪",
  zh: "🇨🇳",
  pt: "🇵🇹",
  ru: "🇷🇺",
  ar: "🇸🇦",
  hi: "🇮🇳",
  vi: "🇻🇳",
  ko: "🇰🇷",
  ja: "🇯🇵",
  tl: "🇵🇭",
};

// Initialize i18next
const initI18n = () => {
  i18next.use(LanguageDetector).init({
    resources: localeResources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: "common",
    ns: localeNamespaces,

    // Language detection options
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes
    },

    // React options
    react: {
      useSuspense: true,
    },

    // Use natural English strings as keys
    keySeparator: false, // Keys are natural text, no nested structure
    nsSeparator: false, // Namespace is passed via useTranslation(ns), not in the key
  });

  return i18next;
};

export const i18nInstance = initI18n();
export default i18nInstance;
